<script setup>
import { formatNumber } from "@/utils/helpers";
import { onMounted } from "vue";

const props = defineProps({
  LoteStore: Object,
  confirmacionAlert: Object,
  mensaje: {
    type: String,
    default: "Ups, hubo un problema al enviar tu oferta, intente nuevamente."
  }
});

let timerId = null;

function cerrarModal() {
  props.confirmacionAlert.hide();
  clearTimeout(timerId);
}

function subirOferta() {
  props.LoteStore.incrementarOferta();
  cerrarModal();
}

onMounted(() => {
  const modalEl = document.getElementById("ofertaWarningModal");

  if (modalEl) {
    modalEl.addEventListener("shown.bs.modal", () => {
      timerId = setTimeout(() => {
        cerrarModal();
      }, 4000);
    });

    modalEl.addEventListener("hidden.bs.modal", () => {
      clearTimeout(timerId);
    });
  }
});
</script>

<template>
  <div class="modal fade" id="ofertaWarningModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content text-center p-5 position-relative">
        <!-- Botón de cierre -->
        <button type="button"
          class="position-absolute top-0 end-0 m-2 bg-light border-0 rounded-circle d-flex align-items-center justify-content-center"
          style="width: 40px; height: 40px;" @click="cerrarModal" aria-label="Close">
          <span class="fs-4">&times;</span>
        </button>

        <!-- Icono de advertencia -->
        <div class="d-flex justify-content-center mb-3">
          <div class="bg-warning d-flex align-items-center justify-content-center"
            style="width: 60px; height: 60px; border-radius: 50%;">
            <i class="fas fa-exclamation text-white fs-3"></i>
          </div>
        </div>

        <!-- Mensaje dinámico -->
        <h5 class="text-warning fw-bold mb-3">
          {{ mensaje }}
        </h5>

        <!-- Precio -->
        <h2 class="text-warning fw-bold mb-4">
          $ {{ formatNumber(props.LoteStore.panelOferta.nueva_oferta) }}
        </h2>

        <!-- Botón para subir oferta -->
        <button class="btn btn-warning fw-bold" @click="subirOferta">
          Aumentar oferta
        </button>
      </div>
    </div>
  </div>
</template>
